<template>
	<div class="transcript">
		<SubheadLockup
			title="Transcript"
			titleElement="h2"
			button="Download Transcript"
			:visuallyHiddenDescription="visuallyHiddenDescription"
			:buttonAction="downloadTranscript"
		/>

		<!-- Beginning of transcript is shown on load -->
		<div class="transcript-initial" v-html="initial" />

		<!-- Full transcript content gets revealed on cta click -->
		<TransitionExpand ref="transcript">
			<div
				v-show="transcriptExpanded"
				class="transcript-expanded"
				v-html="expanded"
			/>
		</TransitionExpand>

		<a
			href="#"
			class="cta transcript-cta"
			@click.prevent="transcriptExpanded = !transcriptExpanded"
			:aria-expanded="transcriptExpanded"
			v-if="typeof expanded === 'string'"
		>
			Read {{ transcriptExpanded === true ? "less" : "more" }}
			<span
				class="icon"
				:class="transcriptExpanded ? `icon-up` : `icon-down`"
				aria-hidden="true"
			/>
		</a>
	</div>
</template>

<script>
import TransitionExpand from "../transitions/TransitionExpand";
import SubheadLockup from "../subhead-lockup/SubheadLockup";

/**
 * A text layout component for multimedia transcripts with downloadable transcript button.
 */
export default {
	name: "Transcript",
	props: {
		/**
		 * The transcript content displayed when expanded.
		 */
		expanded: {
			type: String,
			required: false
		},

		/**
		 * The transcript content displayed before expanding.
		 */
		initial: {
			type: String,
			required: true
		},

		/**
		 * The URL of the downloadable transcript file.
		 */
		downloadUrl: {
			type: String,
			required: true
		},

		/**
		 * Visually hidden description of a button (a11y).
		 */
		visuallyHiddenDescription: {
			type: String
		}
	},
	components: {
		SubheadLockup,
		TransitionExpand
	},
	data() {
		return {
			transcriptExpanded: false
		};
	},
	methods: {
		downloadTranscript() {
			window.open(this.downloadUrl, "_blank", "");
		}
	}
};
</script>
<style lang="scss">
.transcript {
	.\--modal-open & {
		@include from-md {
			margin: 0 -28px;
		}

		@include from-lg {
			margin: 0;
		}
	}

	&-cta {
		margin-bottom: 36px;
		margin-top: 0;

		.\--modal-open & {
			margin-bottom: 0;
		}

		@include from-lg() {
			margin-bottom: 90px;

			.\--modal-open & {
				margin-bottom: 0;
			}
		}
	}

	&-initial {
		margin-top: 24px;
	}
}
</style>
